import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DownloadIcon from '../../../assets/icons/download-cloud-02.svg';
import Button from '../../../components/Button/Button';
import { PATHNAME } from '../../../pathname';
import CustomPagination from '../../../components/Common/CustomPagination/CustomPagination';
import { getAllUnits, getRegionUnitDirectOrderListing, getRegionUnitProjectListing } from '../../../redux/unitSlice/unitSlice';
import CustomSelectWithFilter from '../../../components/Common/CustomSelect/CustomSelectWithFilter';
import { exportExcel } from '../../../redux/adminUnitReportSlice/adminUnitReportSlice';
import CustomTable from '../../../components/Common/CustomTable/CustomTable';

const AdminDirectOrders = () => {
        const navigate = useNavigate();
        const dispatch = useDispatch();
        const [currentPage, setCurrentPage] = useState(1);
        const pageSize = 10; // Items per page
        const { regionUnitDirectOrdersListing, regionUnitDirectOrdersTotal, loading, allUnitsList } = useSelector((state) => state.unit);
        const [data, setData] = useState({});
        const unitRegionColumns = [
                {
                        title: 'Units / Region',
                        dataIndex: 'UNIT_DISPLAY_NAME',
                        key: 'UNIT_DISPLAY_NAME',
                        align: 'center',
                        width: 200,
                        fixed: 'left',
                        render: (text, record) => (
                                <a
                                        className="text-blue-500 underline cursor-pointer text-right"
                                        onClick={() => navigate(`${PATHNAME.ADMIN_DIRECT_ORDERS}/${encodeURIComponent(text)}/final-preview?&mnfUnit=${record.MNF_UNIT}&unitType=${record.unit_type}`)}>
                                        {text || '--'}
                                </a>
                        ),
                },
                {
                        title: 'No. of Projects',
                        dataIndex: 'project_count',
                        key: 'project_count',
                        align: 'center',
                        fixed: 'left',
                        width: 200,

                        render: (text) => <span className="px-3 py-1 rounded-full bg-blue-50 text-blue-600 border border-blue-200 text-sm font-medium text-right">{`${text} Projects`}</span>,
                },

                {
                        title: 'Revenue',
                        dataIndex: 'revenue',
                        key: 'revenue',
                        align: 'center',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'Project Cost',
                        dataIndex: 'projectCost',
                        key: 'projectCost',
                        align: 'center',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'Other Apportioned Cost',
                        dataIndex: 'aportion',
                        key: 'aportion',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'Other Operational Income',
                        dataIndex: 'operational',
                        key: 'operational',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'Profit/Loss',
                        dataIndex: 'profitLoss',
                        key: 'profitLoss',
                        width: 150,

                        render: (text) => {
                                const value = text && Number(text.split(',').join(''));
                                const color = value < 0 ? 'text-red-500' : 'text-green-500';
                                return <div className={`text-right ${color} text-[14px]`}>{text || '--'}</div>;
                        },
                },

                {
                        title: 'Net Billing',
                        dataIndex: 'netBilling',
                        key: 'netBilling',
                        width: 150,

                        render: (text) => {
                                const value = text && Number(text.split(',').join(''));
                                const color = value < 0 ? 'text-red-500' : 'text-green-500';
                                return <div className={`text-right ${color} text-[14px]`}>{text || '--'}</div>;
                        },
                },
                {
                        title: 'Cash Inflow',
                        dataIndex: 'cashInflow',
                        key: 'cashInflow',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'Cash Outflow',
                        dataIndex: 'cashOutflow',
                        key: 'cashOutflow',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'Net Cashflow',
                        dataIndex: 'netCashFlow',
                        key: 'netCashFlow',
                        width: 150,

                        render: (text) => {
                                const value = text && Number(text.split(',').join(''));
                                const color = value < 0 ? 'text-red-500' : 'text-green-500';
                                return <div className={`text-right ${color} text-[14px]`}>{text || '--'}</div>;
                        },
                },
                {
                        title: 'DM%',
                        dataIndex: 'dmPercentage',
                        key: 'dmPercentage',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
        ];


        useEffect(() => {
                dispatch(
                        getRegionUnitDirectOrderListing({
                                page: currentPage,
                                limit: pageSize,
                        }),
                );
        }, [currentPage]);

        useEffect(() => {
                dispatch(getAllUnits());
        }, []);

        return (
                <div className="pb-14">
                        <div className="px-5 flex flex-col gap-6 pt-8">
                                <div className="flex justify-between">
                                        <div className="font-inter font-semibold text-[24px] leading-[32px] tracking-[0%] text-[#101828]">Direct Orders</div>
                                </div>
                                <div className="text-gray-500 text-sm flex justify-start">* All figures are in Rupees (in Crores).</div>
                                <div className="flex justify-end gap-3">
                                        <CustomSelectWithFilter
                                                showSearch="true"
                                                data={
                                                        Array.isArray(allUnitsList)
                                                                ? allUnitsList.map((value) => ({
                                                                          label: value?.UNIT_DISPLAY_NAME,
                                                                          value: value?.MNF_UNIT,
                                                                  }))
                                                                : []
                                                }
                                                onChange={(value) => {
                                                        dispatch(
                                                                getRegionUnitDirectOrderListing({
                                                                        page: currentPage,
                                                                        limit: pageSize,
                                                                        mnfUnits: value, // single value
                                                                }),
                                                        );
                                                }}
                                                placeholder="Select Unit/Region"
                                                className="w-[15rem]"
                                        />
                                        <Button
                                                text="Export report"
                                                icon={DownloadIcon}
                                                onClick={() =>
                                                        dispatch(
                                                                exportExcel({
                                                                        key: 'admin_direct_orders_list',
                                                                }),
                                                        )
                                                }
                                        />
                                </div>
                        </div>
                        <div className="px-5 flex flex-col gap-6 pt-8">
                                <CustomTable
                                        dataSource={regionUnitDirectOrdersListing}
                                        columns={unitRegionColumns}
                                        loading={loading}
                                />
                                <div>
                                        <CustomPagination
                                                totalItems={regionUnitDirectOrdersTotal}
                                                pageSize={pageSize}
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
                                        />
                                </div>
                        </div>
                </div>
        );
};

export default AdminDirectOrders;
